import {
  createSlice,
} from '@reduxjs/toolkit';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';

export const firstTimeProfilePictureModal = createSlice({
  name: 'firstTimeProfilePictureModal',
  initialState: { open: true, avatarImage: null, skipped: false },
  reducers: {
    setOpen(state, action) {
      return _set(_cloneDeep(state), 'open', action.payload);
    },
    setAvatarImage(state, action) {
      return _set(_cloneDeep(state), 'avatarImage', action.payload);
    },
    skipAddProfilePicture(state) {
      return _set(_cloneDeep(state), 'skipped', true);
    },
  },
});

export const {
  setOpen,
  setAvatarImage,
  skipAddProfilePicture,
} = firstTimeProfilePictureModal.actions;

export default firstTimeProfilePictureModal.reducer;
